// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getFilteredConfigurable = (state: ApplicationState, id: string) => {
    return state.store.data.filteredconfigurable.products[id];
};
